import { useState } from "react";
import type { FormEvent } from "react";
import { completeAdministratorBootstrap, logout } from "./api";
import type { AuthUser } from "./types";

export function BootstrapAdministratorScreen({
  user,
  onCompleted,
}: {
  user: AuthUser;
  onCompleted: () => void;
}) {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (password !== confirmation) {
      setError("两次输入的新密码不一致");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await completeAdministratorBootstrap({ newPassword: password, allowRawArtifacts: consent });
      setPassword("");
      setConfirmation("");
      onCompleted();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "密码设置失败，请重试");
    } finally {
      setBusy(false);
    }
  }

  async function signOut() {
    setBusy(true);
    try {
      await logout();
      onCompleted();
    } catch {
      setError("退出失败，请重试");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-shell">
      <section className="login-card">
        <p className="eyebrow">首次登录</p>
        <h1>设置管理员密码</h1>
        <p className="muted">
          {user.email}，请设置不同于临时密码的新密码。保存后需使用新密码重新登录。
        </p>
        <form className="stack" onSubmit={(event) => void submit(event)}>
          <label>
            新密码
            <input
              aria-label="新密码"
              type="password"
              autoComplete="new-password"
              minLength={12}
              maxLength={128}
              required
              disabled={busy}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          <label>
            确认新密码
            <input
              aria-label="确认新密码"
              type="password"
              autoComplete="new-password"
              minLength={12}
              maxLength={128}
              required
              disabled={busy}
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
            />
          </label>
          <p className="muted">密码至少需要 12 个字符。</p>
          <label className="setting-checkbox-row">
            <input
              aria-label="同意账号级原始内容披露"
              type="checkbox"
              checked={consent}
              disabled={busy}
              onChange={(event) => setConsent(event.target.checked)}
            />
            <span>
              我同意输入的文本和上传的文件可按任务需要发送给所选模型或工具服务商。此选择独立于密码设置，默认不勾选。
            </span>
          </label>
          {error && <p role="alert">{error}</p>}
          <button className="primary" disabled={busy}>
            {busy ? "正在保存…" : "保存并重新登录"}
          </button>
          <button
            className="secondary"
            type="button"
            disabled={busy}
            onClick={() => void signOut()}
          >
            退出登录
          </button>
        </form>
      </section>
    </main>
  );
}
